import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const currentCandidateAISlice = createSlice({
  name: "currentCandidateAI",
  initialState,
  reducers: {
    setCurrentCandidateAI: (_, action) => action.payload,
    resetCurrentCandidateAI: () => null,
  },
});
export const { setCurrentCandidateAI, resetCurrentCandidateAI } = currentCandidateAISlice.actions;
export default currentCandidateAISlice.reducer;